/* es5-ext/object/is-object */ function _(require, module, exports) {
    var isValue = require(347) /* ./is-value */;
    var map = { function: true, object: true };
    module.exports = function (value) {
        return (isValue(value) && map[typeof value]) || false;
    };
}
